import React from 'react';

import { XAxis, YAxis, CartesianGrid, Tooltip, Area, AreaChart } from 'recharts';

import format from 'date-fns/format';
import eachDay from 'date-fns/each_day';

import find from 'lodash/find';

import { observer } from 'mobx-react-lite';
import ObservableAutoSizer from '@vromo/ui/components/ObservableAutoSizer';

interface Props {
    jobsByDay: {
        key: number;
        value: number;
    }[];
    startDate: Date;
    endDate: Date;
}

export default observer<Props>(function JobsCompletedAreaChart({ jobsByDay, startDate, endDate }) {
    const dates = eachDay(startDate, endDate);

    const data = dates.map((d) => {
        const result = { name: format(d, 'DD MMMM YYYY'), value: 0 };

        const jobsCompleted = find(jobsByDay, (j) => j.key == d.getTime());

        result.value = jobsCompleted ? jobsCompleted.value : 0;

        return result;
    });

    return (
        <ObservableAutoSizer customChildren={({ width }: { width: number }) => (
            <AreaChart
                width={width}
                height={220}
                data={data}
                margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0
                }}>
                <CartesianGrid strokeDasharray="3 5" />
                <XAxis
                    dataKey="name"
                    minTickGap={100}
                    tickFormatter={(t) => format(new Date(t), 'Do MMM')}
                />
                <YAxis allowDecimals={false} />
                <Tooltip
                    labelFormatter={(label) => format(new Date(label), 'dddd Do MMMM YYYY')}
                    formatter={(value: number) => [value, 'Jobs Completed']}
                />
                <Area dataKey="value" stroke="#1BA5F5" fill="#1BA5F5" />
            </AreaChart>
        )} />
    );
});
